// show error and close liff window when init error
<template>
  <div id="Main">
    <div id="fixTop">
      <TopHead />
    </div>
    <div
      id="main_content"
      class="main_content"
      :style="{ paddingTop: fixTop + 'px' }"
    >
      <slot />
    </div>
  </div>
</template>
<script>
import TopHead from "@/components/topHead.vue";

export default {
  components: { TopHead },
  data() {
    return {
      fixTop: 117,
    };
  },
  created() {
    this.resizeObserver = null;
  },
  mounted() {
    this.updateFixTopHeight();
    window.addEventListener("resize", this.updateFixTopHeight);
    this.$nextTick(() => {
      const fixTopEl = document.getElementById("fixTop");
      if (fixTopEl && window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(() => {
          this.fixTop = fixTopEl.clientHeight;
        });
        this.resizeObserver.observe(fixTopEl);
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateFixTopHeight);
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
  methods: {
    updateFixTopHeight() {
      this.$nextTick(() => {
        const fixTopEl = document.getElementById("fixTop");
        if (fixTopEl) {
          this.fixTop = fixTopEl.clientHeight;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#Main {
  max-width: 450px;
  margin: 0 auto;
}

#fixTop {
  z-index: 2;
  position: fixed;
  width: 100%;
  max-width: inherit;
}

.main_content {
  /* padding-top: 135px; */
  overflow: auto;
  position: relative;
}
</style>
